// src/backend/api.js
import Cookies from 'js-cookie';

const API_URL = 'https://api.huberway.com';
const MAIL_API_URL = 'https:/campaign.huberway.com';
const MAIL_API_TOKEN = 'b499ab5de4196d8d4e9df6acafd4f61eab2cb98399e3da0e74b5bd22a76a';
const LIST_UID = "6790d59edbd6f";

const isProd = process.env.REACT_APP_PROD === 'true'; 

// 2. Recuperiamo gli URL e il TOKEN
const apiProdUrl = process.env.REACT_APP_API_PROD_URL;
const apiStageUrl = process.env.REACT_APP_API_STAGE_URL_V2;
const apiToken = process.env.REACT_APP_API_TOKEN;

// 3. Definiamo la BASE_URL
const BASE_URL = isProd ? apiProdUrl : apiStageUrl;

// Funzione per ottenere i dettagli dell'account
export const getAccountDetails = async () => {
    // const authToken = Cookies.get('auth_token');
    const authToken = '774766dc33eb73f3abcbb0b19a4f46f4';

    if (!authToken) {
        throw new Error('No auth token found');
    }

    const response = await fetch(`${API_URL}/AuthController/accountDetails`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({auth_token: authToken}),
    });

    if (!response.ok) {
        throw new Error('Failed to fetch account details');
    }

    return await response.json();
};

// Funzione per ottenere i dettagli del sito web
export const getWebsiteDetails = async (website_id) => {
    // const authToken = Cookies.get('auth_token');

    const authToken = '774766dc33eb73f3abcbb0b19a4f46f4';

    if (!authToken) {
        throw new Error('No auth token found');
    }

    const response = await fetch(`${API_URL}/WebsiteController/website`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({auth_token: authToken, website_id}),
    });

    if (!response.ok) {
        throw new Error('Failed to fetch website details');
    }

    return await response.json();
};

//ORDER STATUS (PENDING, CANCELED, COMPLETED)

export const createExternalOrder = async (totem_id, user, cartItems, setLoading, setPaymentURL) => {
    setLoading(true);
    
    // 1. Mappatura prodotti
    const products = cartItems.map(item => {
        const originalPrice = parseFloat(item.price);
        const salePrice = item.sale_price ? parseFloat(item.sale_price) : null;
        
        // Determiniamo il prezzo effettivo
        const effectivePrice = (salePrice !== null && salePrice < originalPrice) 
            ? salePrice 
            : originalPrice;
        const selectedSize = item.selectedSize || item.options?.selectedSize || null;

        // --- FIX: Rilavorazione Options per garantire la presenza di 'order' ---
        let cleanOptions = { ...item.options };
        const attributes = [
            cleanOptions.base?.value ? `Base: ${cleanOptions.base.value}` : null,
            selectedSize ? `Taglia: ${selectedSize}` : null,
        ].filter(Boolean).join(", ");

        // Se esistono le opzioni del carrello, le iteriamo per assicurarci che 'order' sia presente
        if (cleanOptions.optionCartValue) {
            const processedCartValue = {};
            
            Object.keys(cleanOptions.optionCartValue).forEach(key => {
                const values = cleanOptions.optionCartValue[key];
                
                if (Array.isArray(values)) {
                    processedCartValue[key] = values.map(val => ({
                        ...val, // Copia tutte le proprietà esistenti (id, value, etc.)
                        order: val.order !== undefined ? parseInt(val.order) : 0, // FORZA L'INVIO DELL'ORDINE
                        image: val.image || null // Assicura che l'immagine sia passata
                    }));
                } else {
                    processedCartValue[key] = values;
                }
            });

            cleanOptions.optionCartValue = processedCartValue;
        }
        // -----------------------------------------------------------------------

        return {
            product_id: item.id,
            name: item.name,
            quantity: item.qty,
            price: effectivePrice, 
            selectedSize: selectedSize,
            options: {
                ...cleanOptions, // Usiamo l'oggetto options "pulito" e processato
                selectedSize: selectedSize,
                attributes: attributes ? `(${attributes})` : "",
                name: item.name,
                product_type: "physical",
                original_price: originalPrice,
                sale_price: salePrice, 
            }
        };
    });

    // 2. Calcolo Totale
    const totalAmount = cartItems.reduce((sum, item) => {
        const op = parseFloat(item.price);
        const sp = item.sale_price ? parseFloat(item.sale_price) : null;
        const priceToUse = (sp !== null && sp < op) ? sp : op;

        let adjustments = 0;
        // Nota: ho uniformato l'accesso a optionCartValue per sicurezza
        const optionsSource = item.options?.optionCartValue || item.options?.options?.optionCartValue;
        
        if (optionsSource) {
            Object.values(optionsSource).forEach(optArray => {
                if (Array.isArray(optArray)) {
                    optArray.forEach(opt => {
                        adjustments += parseFloat(opt.affect_price || 0);
                    });
                }
            });
        }

        return sum + ((priceToUse + adjustments) * item.qty);
    }, 0);

    const payload = {
        totem_id: totem_id,
        products: products,
        total_amount: totalAmount.toFixed(2),
        currency: "EUR",
        order_status: "pending",
        payment_status: "pending"
    };

    try {
        const response = await fetch(`${BASE_URL}/orders/external/totem`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                'X-User-Token': apiToken
            },
            body: JSON.stringify(payload)
        });

        const data = await response.json();

        if (!response.ok) {
            throw new Error(data.error || "Errore durante la creazione dell'ordine");
        }

        setPaymentURL(data.url_payment);
    } catch (err) {
        console.error("Errore durante la creazione dell'ordine:", err);
    } finally {
        setLoading(false);
    }
};


export const subscribeNewsletter = async (address, name, surname) => {
    await fetch(`${MAIL_API_URL}/api/v1/subscribers`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
        },
        body: JSON.stringify({
            api_token: MAIL_API_TOKEN,
            list_uid: LIST_UID,
            EMAIL: address,
            FIRST_NAME: name,
            LAST_NAME: surname
        }),
    })
}

